// FETCH ALL PROPERTIES FROM PROPERTY PAGE
export const FETCH_PROPERTY_REQUEST = 'FETCH_PROPERTY_REQUEST';
export const FETCH_PROPERTY_SUCCESS = 'FETCH_PROPERTY_SUCCESS';
export const FETCH_PROPERTY_FAILURE = 'FETCH_PROPERTY_FAILURE';

//FETCH DROPDOWN PROPERTY FOR PROPERTY PAGE
export const FETCH_DROPDOWN_PROPERTY_REQUEST = 'FETCH_DROPDOWN_PROPERTY_REQUEST';
export const FETCH_DROPDOWN_PROPERTY_SUCCESS = 'FETCH_DROPDOWN_PROPERTY_SUCCESS';
export const FETCH_DROPDOWN_PROPERTY_FAILURE = 'FETCH_DROPDOWN_PROPERTY_FAILURE';

// CREATE PROPERTIES FOR PROPERTY PAGE
export const CREATE_PROPERTY_REQUEST = 'CREATE_PROPERTY_REQUEST';
export const CREATE_PROPERTY_SUCCESS = 'CREATE_PROPERTY_SUCCESS';
export const CREATE_PROPERTY_FAILURE = 'CREATE_PROPERTY_FAILURE';

// MaxSlNo
export const MAX_PROPERTY_SLNO_REQUEST = 'MAX_PROPERTY_SLNO_REQUEST';
export const MAX_PROPERTY_SLNO_SUCCESS = 'MAX_PROPERTY_SLNO_SUCCESS';
export const MAX_PROPERTY_SLNO_FAILURE = 'MAX_PROPERTY_SLNO_FAILURE';

// UPDATE PROPERTIES FOR PROPERTY PAGE
export const UPDATE_PROPERTY_REQUEST = 'UPDATE_PROPERTY_REQUEST';
export const UPDATE_PROPERTY_SUCCESS = 'UPDATE_PROPERTY_SUCCESS';
export const UPDATE_PROPERTY_FAILURE = 'UPDATE_PROPERTY_FAILURE';

// FETCH SINGLE PROPERTY FOR PROPERTY PAGE
export const FETCH_SINGLE_PROPERTY_REQUEST = 'FETCH_SINGLE_PROPERTY_REQUEST';
export const FETCH_SINGLE_PROPERTY_SUCCESS = 'FETCH_SINGLE_PROPERTY_SUCCESS';
export const FETCH_SINGLE_PROPERTY_FAILURE = 'FETCH_SINGLE_PROPERTY_FAILURE';

// DELETE PROPERTIES FOR PROPERTY PAGE
export const DELETE_PROPERTY_REQUEST = 'DELETE_PROPERTY_REQUEST';
export const DELETE_PROPERTY_SUCCESS = 'DELETE_PROPERTY_SUCCESS';
export const DELETE_PROPERTY_FAILURE = 'DELETE_PROPERTY_FAILURE';

export const CREATE_USER_FORM_PROPERTY = 'CREATE_USER_FORM_PROPERTY';
export const PROPERTY_USERFORM_RESET = 'PROPERTY_USERFORM_RESET';
